export const gridContainerTypes = {
  upper: 'upper',
  basement: 'basement',
  under: 'under',
};
